module.exports = __webpack_public_path__ + "static/media/instagram.26f89cd9.png";


//////////////////
// WEBPACK FOOTER
// ./client/socialMediaLogos/instagram.png
// module id = 473
// module chunks = 0